import type { PluginPlanCardAction } from './pluginPlanChangeUtils';

type PluginPlanSubmissionAction = Exclude<PluginPlanCardAction, 'current-plan' | 'renew' | 'renew-and-switch'>;

interface PluginSubscriptionResponse {
    success?: boolean;
    paymentUrl?: string | null;
}

export type PluginPlanSubmissionOutcome =
    | { kind: 'scheduled-downgrade'; ignoredCheckoutUrl: boolean }
    | { kind: 'checkout'; paymentUrl: string }
    | { kind: 'direct-subscription-success' }
    | { kind: 'failed' };

/**
 * A downgrade changes the next renewal only. It is never a checkout completion,
 * even if an unexpected legacy response happens to include a payment URL.
 */
export const resolvePluginPlanSubmissionOutcome = ({
    action,
    response,
}: {
    action: PluginPlanSubmissionAction;
    response?: PluginSubscriptionResponse | null;
}): PluginPlanSubmissionOutcome => {
    if (!response?.success) {
        return { kind: 'failed' };
    }

    if (action === 'downgrade') {
        return {
            kind: 'scheduled-downgrade',
            ignoredCheckoutUrl: Boolean(response.paymentUrl),
        };
    }

    if (typeof response.paymentUrl === 'string' && response.paymentUrl.trim()) {
        return { kind: 'checkout', paymentUrl: response.paymentUrl };
    }

    return { kind: 'direct-subscription-success' };
};
